import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { trackCtaClick } from "@/lib/track";
import { useMarket } from "@/i18n/MarketContext";
import { useLanguage } from "@/i18n/LanguageContext";

export default function StickyBar() {
  const { t, lang } = useLanguage();
  const { market, ctaUrl } = useMarket();

  return (
    <motion.div
      initial={{ y: 96, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.9, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      data-testid="sticky-bottom-bar"
      className="fixed inset-x-0 bottom-0 z-50 flex justify-center"
    >
      <div className="w-full max-w-[480px] px-4 pb-[max(0.4rem,env(safe-area-inset-bottom))]">
        <div className="rounded-2xl border border-[rgba(22,99,230,0.16)] bg-white/95 p-1.5 shadow-[0_12px_32px_-14px_rgba(11,61,145,0.35)] backdrop-blur-xl">
          <p className="pb-1.5 pt-0.5 text-center text-[11px] leading-[15px] text-slate-500" data-testid="sticky-cta-helper">
            {t("ctaHelper")}
          </p>
          <a
            href={ctaUrl}
            target="_blank"
            rel="noopener noreferrer sponsored"
            id="partner-cta"
            data-event="cta_partner_click"
            aria-label={t("ctaGo")}
            data-testid="sticky-bottom-cta-button"
            onClick={() =>
              trackCtaClick({ position: "sticky", market, language: lang, destination: ctaUrl })
            }
            className="group flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-[#1663E6] text-[15px] font-semibold tracking-wide text-white transition-[background-color,transform] duration-300 hover:bg-[#0F53C9] active:scale-[0.98]"
          >
            {t("ctaGo")}
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#F2B705] text-[#0B3D91]">
              <ArrowUpRight className="h-3 w-3" strokeWidth={2.5} />
            </span>
          </a>
        </div>
      </div>
    </motion.div>
  );
}
